import { createProp } from '@thyme/nashville/src/utils/designTokens'

export enum ButtonType {
  Primary = '', // Default
  Text = 'text',
  Outlined = 'outlined',
  Link = 'link',
}
/**
 *
 * @param opts
 * @param opts.default
 * @param opts.required
 */
export function makeButtonTypeProp(opts?: {
  default?: string
  required?: boolean
}) {
  return { type: createProp(ButtonType, opts?.default, opts?.required) }
}

export enum TButtonType {
  Primary = 'primary',
  PrimaryOutline = 'primaryOutline',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  BlackAndWhite = 'blackAndWhite',
  Danger = 'danger',
  Success = 'success',
  Transparent = 'transparent',
  WhiteAndGray = 'whiteAndGray',
  WhiteAndPurple = 'whiteAndPurple',
  WhiteAndPurpleSecondary = 'whiteAndPurpleSecondary',
  WhiteAndPurpleTertiary = 'whiteAndPurpleTertiary',
}

export enum ButtonSize {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}
